<template>
<v-card tile flat>
  <v-toolbar v-if='title' class='black white--text mb-5' flat >
    <v-toolbar-title v-text='title' ></v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>

  <wizard-view
    v-model='location'
    :step.sync='step'
    :steps='steps'
    :loading='request.loading'
    :overlay='block'
    :is-valid='isValid'
    :with-success-screen='false'
    :with-delete='false'
    v-on='$listeners'
    @save='createLocation'
    @close='$emit("close")'
    @reset='reset' />

</v-card>
</template>
<script>
import WizardView from '@/components/layouts/WizardView.vue'
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import DataForm from '@/components/data/DataForm.vue'
import LocationForm from '@/components/actions/LocationForm.vue'
import Vue from 'vue'

export default {
  name: 'NewLocationWizard',
  components: {WizardView},
  props: {
    spaceId: { required: false },
    loading: { type: Boolean, default: false },
    touch: { type: Number, default: 0 },
    title: { type: String }
  },
  data () {
    return {
      step: 0,
      block: false,
      location: {},
      request: {
        resource: 'ag.spaces',
        extra: 'addresses',
        method: 'post'
      }
    }
  },
  methods: {
    reset () {
      this.location = {
        service: this.spaceId
      }
      this.step = 0
    },
    createLocation () {
      this.block = true
      this.request.data = this.location
      this.request.resourceId = this.spaceId
      this.request.method = 'post'
      this.$request('save', this.request)
    }
    // wizardSaved () {
    //   this.$emit('saved', this.location)
    //   if (this.currentStep && this.currentStep.id === 'loc-details') {
    //     this.$emit('close')
    //   }
    // }
  },
  watch: {
    touch () { this.reset() },
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          Vue.set(this.location, 'service', this.spaceId)
        }
      }
    },
    requestStatus () {
      if (this.requestStatus === 201) {
        this.step ++
        this.block = false
        this.location = this.request.result
        this.request.method = 'patch'
        this.$emit('saved', this.request.result)
        // this.request.resourceId = this.spaceId
        // this.request.extra = 'addresses/' + this.locationId
      }
      if (this.requestStatus === 200) {
        this.location = this.request.result
        this.$emit('saved', this.request.result)
      }
      if (this.requestStatus > 0) {
        this.block = false
      }
    }
  },
  computed: {
    requestStatus () { return this.request.status },
    isValid () {
      if (this.location.service && this.location.name) {
        return true
      } else {
        return false
      }
    },
    locationId () {
      if (this.location && this.location.id) {
        return this.location.id
      } else {
        return null
      }
    },
    currentStep () {
      if (this.step && this.steps && this.step < this.steps.length) {
        return this.steps[this.step]
      }
      return null
    },
    steps () {
      let steps = []
      if (!this.spaceId) {
        steps.push({
          id: 'loc-space',
          title: 'Pick a Space',
          subtitle: 'Which Space do you want to add this location to?',
          component: SpacePicker
        })
      }
      steps.push({
        id: 'loc-name',
        title: 'Give this location a name',
        subtitle: `A descriptive name for this location. For example: This appointment is at: ${this.spaceName}, <code>{location name}</code>`,
        next: this.createLocation,
        component: DataForm,
        attrs: {
          value: this.location,
          fields: [
            {
              attrs: {
                label: 'Location name',
                solo: true,
                filled: true
              },
              id: 'name'
            }
          ]
        }
      })
      steps.push({
        id: 'loc-details',
        title: 'Location details',
        subtitle: 'Configure your location',
        component: LocationForm,
        withDone: true,
        attrs: {
          spaceId: this.spaceId,
          locationId: this.locationId,
          withTitle: false,
          withDelete: false
        }
      })
      return steps
    }
  }
}
</script>